import { useQuery, useMutation } from '@tanstack/react-query';
import { getRewardList, deleteReward, redeemReward, updateReward } from '../api/reward';

export const useGetRewardList = ({ enabled = true, ...params }) => {
  return useQuery({
    queryKey: ['rewardList', params],
    queryFn: ({ signal }) => getRewardList(params, signal),
    enabled,
  });
};

export const useDeleteReward = () => {
  return useMutation({
    mutationFn: ({ params, signal }) => deleteReward(params, signal),
  });
};

export const useRedeemReward = () => {
  return useMutation({
    mutationFn: ({ dto, signal }) => redeemReward(dto, signal),
  });
};

export const useUpdateReward = () => {
  return useMutation({
    mutationFn: ({ params, dto, signal }) => updateReward(params, dto, signal),
  });
};
